import { render, staticRenderFns } from "./ticketReport.vue?vue&type=template&id=a6cf1068&scoped=true&"
import script from "./ticketReport.vue?vue&type=script&lang=js&"
export * from "./ticketReport.vue?vue&type=script&lang=js&"
import style0 from "./ticketReport.vue?vue&type=style&index=0&id=a6cf1068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cf1068",
  null
  
)

export default component.exports